// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanMutateRiskFactors } from "./hook";

export type CanMutateRiskFactorsProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanMutateRiskFactors({
  children,
  fallback,
  scope,
}: CanMutateRiskFactorsProps) {
  const canDoAction = useCanMutateRiskFactors(scope);
  return <>{canDoAction ? children : fallback}</>;
}
